import { useState } from "react";
import Filter from "../Filter/filter";
import FilterList from "../global/FilterList";
import {
  filterIcons,
  readerAction01MenuData,
  readerAction02MenuData,
  readingDirectionMenuData,
  scriptProximityMenuData,
  textBehaviourMenuData,
} from "../../assets/text/filterData";
import {
  isReaderAction01Disabled,
  isReaderAction02Disabled,
  isTextBehaviourDisabled,
} from "../../util/filterHelpers";

const getDefaultOption = (label, arLabel, iconPath) => ({
  englishName: label,
  arabicName: arLabel,
  icon: <img alt="icon" src={iconPath} className="svg-icons" />,
});

const FilterHeader = ({
  handleApply,
  applyState,
  handleReset,
  handleFiltersApplied,
  filterApplied,
}) => {
  const defaultOptions = [
    getDefaultOption(
      "reading direction",
      "اتجاه القراءة",
      "/icons/reading_direction.svg"
    ),
    getDefaultOption(
      "script proximity",
      "تقارب الخطوط",
      "/icons/script_proximity.svg"
    ),
    getDefaultOption("book flip", "عكس الكتاب", "/icons/reader_action01.svg"),
    getDefaultOption(
      "text behaviour",
      "سلوك النص",
      "/icons/text_behaviour.svg"
    ),
    getDefaultOption(
      "book rotation",
      "تدوير الكتاب",
      "/icons/reader_action02.svg"
    ),
  ];

  const [filterOptions, setFilterOptions] = useState(
    filterApplied.map((val, i) =>
      val !== -1
        ? {
            englishName: filterIcons[val - 1].englishName,
            arabicName: filterIcons[val - 1].arabicName,
            icon: filterIcons[val - 1].icon,
          }
        : defaultOptions[i]
    )
  );

  const handleReadingDirection = ({ key }) => {
    const newFilters = [...filterApplied];
    const newOptions = [...filterOptions];

    let index = -1;
    if (key >= 1 && key <= 4) index = 0;
    else if (key >= 5 && key <= 6) index = 1;
    else if (key >= 7 && key <= 9) index = 2;
    else if (key >= 10 && key <= 11) index = 3;
    else if (key >= 12 && key <= 13) index = 4;

    if (index === -1) return;

    // If the selected filter is already active, unselect it
    if (newFilters[index] === key) {
      newFilters[index] = -1;
      newOptions[index] = defaultOptions[index];
    } else {
      newFilters[index] = key;
      const matched = filterIcons.find((item) => item.key === key);
      newOptions[index] = {
        englishName: matched.englishName,
        arabicName: matched.arabicName,
        icon: matched.icon,
      };
    }

    setFilterOptions(newOptions);
    handleFiltersApplied(newFilters);
  };

  const handleResetClick = () => {
    const resetFilters = [-1, -1, -1, -1, -1];
    setFilterOptions(defaultOptions);
    handleReset(true);
    handleFiltersApplied(resetFilters);
  };

  const filterArray = [
    {
      data: readingDirectionMenuData,
      key: filterApplied[0],
      set: handleReadingDirection,
      name: filterOptions[0],
      tooltipEng: "The opening side of the book",
      tooltipArab: "اتجاه فتح الكتاب",
    },
    {
      data: scriptProximityMenuData,
      key: filterApplied[1],
      set: handleReadingDirection,
      name: filterOptions[1],
      tooltipEng: "Scripts are mixed or separated",
      tooltipArab: "النّصان متداخلان أو منفصلان",
    },
    {
      data: readerAction01MenuData,
      key: filterApplied[2],
      set: handleReadingDirection,
      getDisabled: isReaderAction01Disabled,
      name: filterOptions[2],
      tooltipEng: "Flip the book to read the other script",
      tooltipArab: "عكس الكتاب لقراءة النص الآخر",
    },
    {
      data: textBehaviourMenuData,
      key: filterApplied[3],
      set: handleReadingDirection,
      getDisabled: isTextBehaviourDisabled,
      name: filterOptions[3],
      tooltipEng: "Scripts run parallel or cross",
      tooltipArab: "النصان متوازيان أو عابران",
    },
    {
      data: readerAction02MenuData,
      key: filterApplied[4],
      set: handleReadingDirection,
      getDisabled: isReaderAction02Disabled,
      name: filterOptions[4],
      tooltipEng: "Rotate book 90˚ or 180˚",
      tooltipArab: "تدوير الكتاب حسب النص",
    },
  ];

  return (
    <div className="filter-header">
      {filterArray.map((val, index) => (
        <Filter
          key={index}
          titleArabic={val.name.arabicName}
          titleEng={val.name.englishName}
          icon={val.name.icon}
          tooltiptextEng={val.tooltipEng}
          tooltiptextArab={val.tooltipArab}
          applyState={applyState}
          menu={
            <FilterList
              items={val.data}
              activeKey={val.key}
              onSelect={val.set}
              getDisabled={val.getDisabled}
              allFilters={filterApplied}
            />
          }
        />
      ))}

      <div className="filter-actions">
        <div
          className="apply-btn"
          onClick={() => {
            handleApply(false);
            setTimeout(() => handleApply(true), 100);
          }}
        >
          apply
          <span style={{ marginInlineStart: "4px" }}>•</span>
          <span className="btn-ar">تطبيق</span>
        </div>
        <div className="reset-btn" onClick={handleResetClick}>
          reset
          <span style={{ marginInlineStart: "4px" }}>•</span>
          <span className="btn-ar">إعادة</span>
        </div>
      </div>
    </div>
  );
};

export default FilterHeader;
